import { http } from "./http.js";
import { ui } from "./ui.js";

const uiEvents = {

    mixpanel: {
        addEvent: async (eventName, action, aditionalProperties = null) => {
            const endpoint = window.appvars.services.mixpanel.addEvent;

            await http.post(endpoint, {
                event: eventName,
                action: action,
                aditionalProperties: aditionalProperties,
            });
        }
    },

    toolbar: {

        setAddNewAppBtn: async () => {

            const btnAddNewApp = document.getElementById("aNewMenuCreateProcess");
            if (!btnAddNewApp) return;

            btnAddNewApp.addEventListener("click",
                async () => {

                    const data = await http.post(window.appvars.services.flows.addroute);

                    if (!data.success) return;

                    const url = data.success.url;
                    const size = data.success.size;

                    if (!size) {
                        window.open(data.success.url);
                        return;
                    }
                    ui.modal(url, size);

                });
        }
    },

    topbar: {
        setClickHelpMenuOption: async () => {
            let optHelpMenu = document.querySelectorAll('[data-menu-desc]');
            if (!optHelpMenu || !optHelpMenu.length) return;

            optHelpMenu.forEach((optMenu) => {
                optMenu.addEventListener("click",
                    async () => {
                        let aditionalProperties = {
                            help_menu_item: optMenu.getAttribute('data-menu-desc')
                        }
                        uiEvents.mixpanel.addEvent("Central de ajuda", "Click", aditionalProperties);
                    });
            });
        }
    }
}

document.addEventListener("DOMContentLoaded", () => {
    
    uiEvents.toolbar.setAddNewAppBtn();
    uiEvents.topbar.setClickHelpMenuOption();

});